import { API } from 'aws-amplify';
import {
    getMuleConfig,
    handleError,
    MULE_API_NAME,
    validateResponse,
} from './apiUtils';

export function getMerchantList() {
    const path = `loyalty/v1/api/v1/merchant/list`;

    return getMuleConfig()
        .then((config) => API.get(MULE_API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}

export function getMerchantDetails(merchantId) {
    const path = `loyalty/v1/api/v1/merchant/info?merchantId=${merchantId}`;

    return getMuleConfig()
        .then((config) => API.get(MULE_API_NAME, path, config))
        .then(validateResponse)
        .catch(handleError);
}
